/**
 * Join class names, dropping anything falsy.
 *
 * This is NOT `tailwind-merge` — it cannot resolve two utilities that set the
 * same CSS property. Tailwind emits colour utilities at equal specificity, so a
 * conflict is decided by stylesheet order rather than by the order given here.
 * An invalid input rendered with the normal grey border for exactly that reason.
 *
 * The rule this folder follows instead: a component must emit at most one
 * utility per property, choosing between variants rather than layering them.
 * See `fieldClasses` in field.jsx for the pattern.
 *
 * @param {...(string|false|null|undefined)} parts
 * @returns {string}
 */
export const cn = (...parts) => parts.filter(Boolean).join(" ");
